import router from '@/router'
import TransitService from '@/services/TransitService'
import ShuttleService from '@/services/ShuttleService'

export default {
  state: {
    activeTransitStop: null,
    departures: [],
    vehicles: [],
    campusShuttleSettings: {
      requireIsDriving: false,
      requireIsDeviceCommunicating: true,
      requireIsInService: true
    },
    campusShuttles: []
  },
  getters: {
    activeTransitStop: state => state.activeTransitStop,
    departures: state => state.departures,
    vehicles: state => state.vehicles,
    activeCampusShuttles: state => {
      const output = {}

      Object.entries(state.campusShuttles).forEach((entry) => {
        const [key, shuttle] = entry

        if (
          (shuttle.isDriving || !state.campusShuttleSettings.requireIsDriving) &&
          (shuttle.isDeviceCommunicating || !state.campusShuttleSettings.requireIsDeviceCommunicating) &&
          (shuttle.isInService || !state.campusShuttleSettings.requireIsInService)
        ) {
          output[key] = shuttle
        }
      })

      return output
    }
  },
  mutations: {
    setActiveTransitStop (state, data) {
      if (data && data.stopId) {
        router.push({ name: 'transit', params: { stopId: data.stopId } })
      }

      state.activeTransitStop = data
    },
    setDepartures (state, data) {
      state.departures = data
    },
    setVehicles (state, data) {
      state.vehicles = data
    },
    setCampusShuttles (state, data) {
      state.campusShuttles = data
    }
  },
  actions: {
    async loadDepartures ({ commit }, id) {
      const response = await TransitService.getDepartures(id)
      commit('setDepartures', response)
    },
    async loadVehicles ({ commit }, id) {
      const response = await TransitService.getVehicles(id)
      commit('setVehicles', response)
    },
    async loadCampusShuttles ({ commit }) {
      const response = await ShuttleService.getShuttles()
      commit('setCampusShuttles', response)
    }
  }
}
